<template>
  <div>
    <loading v-if="load" text="Transferindo atendimento.." full="true" style="top: 32%"/>
    <div v-show="!load">
      <h6 class="mt-1 mb-2 text-center font-weight-bold">Transferir Atentendimento</h6>
      <div class="mb-2">
        <div class="rounded position-relative w-100">
          <i class="fa fa-search small" style="position: absolute; top: 12px; left: 16px"></i>
          <VueFuse id="searchAgent" :list="agents" :fuse-opts="option" :map-results="true"
                   placeholder="Pesquisar agente" class="form-control border-0 rounded pl-5 bg-lebot"
                   @fuse-results="handleResults"/>
        </div>
      </div>
      <a class="d-flex justify-content-between align-items-center text-dark text-decoration-none p-2 border-top" href="javascript:"
         v-for="a in searchResults" v-if="a.id !== dados.agent_id" @click="transfer(a.id)">
        <div>{{ a.name }}</div>
        <i class="fa fa-angle-right text-secondary"></i>
      </a>
    </div>
  </div>
</template>

<script>
import VueFuse from "vue-fuse";
import Loading from "@/components/loading";

export default {
  name: "TransferChat",
  props: ['dados'],
  components: {Loading, VueFuse},
  data() {
    return {
      load: true,
      term: '',
      agents: [],

      searchResults: [],
      option: {
        shouldSort: true,
        threshold: 0.2,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['name']
      }
    }
  },

  methods: {
    handleResults(r) {
      this.searchResults = r;
    },

    getAgents() {
      this.load = true;
      this.$http.get('agents')
        .then(response => {
          this.load = false;
          this.agents = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    transfer(id) {
      if (this.load || (!id || !this.dados.id)) {
        return;
      }

      const dados = {
        contact_id: this.dados.id,
        agent_id: id,
      }

      this.load = true;

      this.$http.post('contacts/transfer', dados)
        .then(res => {
          this.load = false;
          this.$emit('close');

          if (!res.data || !res.data.success) {
            this.$swal('Não foi possível transferir este atendimento!');
            return;
          }

          this.$emit('atualizar');

        }, res => {
          this.load = false;
          this.$swal('Não foi possível transferir este atendimento!');
        });
    }
  },

  mounted() {
    this.getAgents();
  }
}
</script>

<style scoped>

</style>
